<ng-container *ngFor="let league of topLeaguesData">
  <div class="item" (click)="getMatch(league)">
    <div class="left">
      <div class="league">
        <league-utils [extraClass]="'left-menu-desktop'" [leagueId]="league.BetradarId"></league-utils>
      </div>
    </div>
    <div class="mid">{{ league.TournamentName }}</div>
    <div class="right-mobile">
      {{ league.TournamentSportEventCount }}
      <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon right'"> </image-loader-utils>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="topLeaguesData == undefined || topLeaguesData?.length < 1">
  <ngx-skeleton-loader [theme]="{ height: '19px', width: '223px', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
</ng-container>
